import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LanguageToggle } from './LanguageToggle';
import { useLanguage } from '../contexts/LanguageContext';
import { LINKS } from '../data/translations';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    t
  } = useLanguage();
  const navLinks = [{
    label: t.nav.how,
    href: '#how-it-works'
  }, {
    label: t.nav.why,
    href: '#why-us'
  }];
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200/80 bg-white/90 backdrop-blur" data-id="element-72" data-mp="2wl8nheqo78mz">
      <div className="mx-auto flex h-[76px] w-full max-w-[1280px] items-center justify-between px-5 sm:px-8" data-id="element-73" data-mp="31c8ksl3pbsq0">
        <Logo data-id="element-74" data-mp="36bl794qnuxs2" />

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Main navigation" data-id="element-75" data-mp="36a0bjbsm18sm">
          {navLinks.map(link => <a key={link.label} href={link.href} className="text-[15px] text-slate-600 transition-colors hover:text-slate-900" data-id="element-76" data-mp="3b8bohve7bzf2">
              {link.label}
            </a>)}
          <LanguageToggle data-id="element-77" data-mp="2rlhzk9828c3p" />
          <span className="h-6 w-px bg-slate-200" aria-hidden="true" data-id="element-78" data-mp="2rk6pjro0u845" />
          <a href={LINKS.login} target="_blank" rel="noreferrer" className="text-[15px] font-semibold text-slate-900 transition-colors hover:text-blue-600" data-id="element-79" data-mp="2mlvghj5jw1mz">
            {t.nav.login}
          </a>
          <a href={LINKS.register} target="_blank" rel="noreferrer" className="rounded-full bg-blue-600 px-6 py-3 text-[15px] font-bold text-white shadow-sm transition-colors hover:bg-blue-700" data-id="element-80" data-mp="3fd6nlddumeeu">
            {t.nav.getStarted}
          </a>
        </nav>

        <div className="flex items-center gap-3 lg:hidden" data-id="element-81" data-mp="1w5zazhdk3r4">
          <LanguageToggle data-id="element-82" data-mp="1xqtgnzs1kog" />
          <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 transition-colors hover:bg-slate-100" aria-expanded={open} aria-label={t.nav.menu} data-id="element-83" data-mp="3tb3nojrih2y9">
            {open ? <XIcon size={22} data-id="element-84" data-mp="1ho9w6yvtyldq" /> : <MenuIcon size={22} data-id="element-85" data-mp="1hmqfx8a6caby" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-slate-200 bg-white px-5 py-4 lg:hidden" data-id="element-86" data-mp="1mlt99vgsks43">
          <nav className="flex flex-col gap-1" aria-label="Mobile navigation" data-id="element-87" data-mp="18mk6pylidwil">
            {navLinks.map(link => <a key={link.label} href={link.href} onClick={() => setOpen(false)} className="rounded-lg px-2 py-3 text-[15px] text-slate-600 hover:bg-slate-50" data-id="element-88" data-mp="1cpq74plxwth5">
                {link.label}
              </a>)}
            <a href={LINKS.login} target="_blank" rel="noreferrer" className="rounded-lg px-2 py-3 text-[15px] font-semibold text-slate-900 hover:bg-slate-50" data-id="element-89" data-mp="2t3ykbtktlqg4">
              {t.nav.login}
            </a>
            <a href={LINKS.register} target="_blank" rel="noreferrer" className="mt-2 rounded-full bg-blue-600 px-6 py-3 text-center text-[15px] font-bold text-white" data-id="element-90" data-mp="hg3gm0we0gca">
              {t.nav.getStarted}
            </a>
          </nav>
        </div>}
    </header>;
}